export default __webpack_public_path__ + "static/ask-question-big-simple-8865622e8dbee42ec9d9acbd0bd2ee9b.svg";